import { render, staticRenderFns } from "./KOT_Order.vue?vue&type=template&id=56f4cdc1&"
import script from "./KOT_Order.vue?vue&type=script&lang=js&"
export * from "./KOT_Order.vue?vue&type=script&lang=js&"
import style0 from "./KOT_Order.vue?vue&type=style&index=0&media=print&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports